import { useState } from 'react';
import { Icon } from '@mui/material';
import './FaqsContent.scss';

const FaqsContent = ({
	faqTitle,
	faqContent,
	expanded = false
}) => {
	const [faqExpanded, setFaqExpanded] = useState(expanded);

	const faqItemClassName = `info-icon${faqExpanded ? ' active' : ''}`;
	
	return (
		<div className='faq-container'>
			<div
				className='faq-header'
				onClick={() => setFaqExpanded(!faqExpanded)}
			>
				<Icon className={faqItemClassName}>info</Icon>
				<h3 className='faq-title'>{faqTitle}</h3>
				<span className='faq-data-expander'>
					{!faqExpanded && (
						<Icon className='expand-control'>
							expand_more
						</Icon>
					)}

					{faqExpanded && (
						<Icon className='expand-control'>
							expand_less
						</Icon>
					)}
				</span>
			</div>
			{faqExpanded && (
				<p className='faqs-paragraph'>{faqContent}</p>
			)}
		</div>
	);
};
export default FaqsContent;
